import React from "react";
import { Link } from "react-router-dom";

function OrderSuccessModal({ orderId }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="flex flex-col items-center gap-4">
          <svg
            className="w-16 h-16 text-green-500 mb-2"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <h2 className="text-2xl font-bold text-gray-800">
            Order Placed Successfully!
          </h2>
          <p className="text-gray-600">
            Your order has been placed. You can view the details of your order
            below.
          </p>
          <div className="bg-gray-100 rounded-lg px-4 py-2 text-gray-700 font-mono text-sm mb-2">
            Order ID: {orderId}
          </div>
          <Link
            to={`/user/dashboard/orders?tab=details&orderId=${orderId}`}
            className="mt-4 inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-6 rounded-lg shadow transition"
          >
            Go to Order Details
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccessModal;
